import { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';
import { isCheckoutOptimizationVariant } from '../shared/helpers/checkoutOptimizationAbTestHelpers';
import { BuyerIncentives } from '../components/shared/BuyerIncentives';
import { isEnhancedBuyerIncentivesVariant } from '../helpers/isEnhancedBuyerIncentivesVariant';

import { Link } from 'dibs-elements/exports/Link';
import Logo from 'dibs-logo/exports/Logo';
import LockIcon from 'dibs-icons/exports/legacy/Lock';

import CheckoutTitle from './CheckoutTitle';
import CheckoutContact from './CheckoutContact';

import styles from './styles/CheckoutMobileHeader.scss';

const CheckoutMobilePageHeaderComponent = ({ viewer, buyer, item, setHasTradeStatus }) => {
    const isEnhancedBuyerIncentivesClientVariant = isEnhancedBuyerIncentivesVariant();

    useEffect(() => {
        if (buyer && buyer.isTrade) {
            setHasTradeStatus();
        }
    }, [buyer, setHasTradeStatus]);

    const headerClassName = classnames(styles.wrapper, {
        [styles.isOptimizationVariant]:
            isCheckoutOptimizationVariant() && !isEnhancedBuyerIncentivesClientVariant,
        [styles.isEnhancedBuyerIncentivesClientVariant]:
            isEnhancedBuyerIncentivesClientVariant && !isCheckoutOptimizationVariant(),
        [styles.combinedVariants]:
            isEnhancedBuyerIncentivesClientVariant && isCheckoutOptimizationVariant(),
    });

    return (
        <>
            <div id="checkout-header" className={headerClassName}>
                <div className={styles.header}>
                    <Link href="/" dataTn="checkout-mobile-page-header-logo">
                        <Logo className={styles.logoIcon} />
                    </Link>
                    <div className={styles.rightContent}>
                        <LockIcon className={styles.lockIcon} />
                        <CheckoutTitle />
                        <CheckoutContact />
                    </div>
                </div>
            </div>
            {isEnhancedBuyerIncentivesClientVariant && (
                <div
                    className={classnames(styles.buyerIncentives, {
                        [styles.isOptimizationVariant]: isCheckoutOptimizationVariant(),
                    })}
                >
                    {viewer && (
                        <BuyerIncentives
                            viewer={viewer}
                            buyer={buyer}
                            item={item}
                            incentiveClassName={styles.buyerIncentive}
                        />
                    )}
                </div>
            )}
        </>
    );
};

CheckoutMobilePageHeaderComponent.propTypes = {
    buyer: PropTypes.object,
    viewer: PropTypes.object,
    item: PropTypes.object,
    setHasTradeStatus: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
    setHasTradeStatus: () => dispatch({ type: 'HAS_TRADE_STATUS' }),
});

export const CheckoutMobilePageHeader = createFragmentContainer(
    connect(null, mapDispatchToProps)(CheckoutMobilePageHeaderComponent),
    {
        viewer: graphql`
            fragment CheckoutMobilePageHeader_viewer on Viewer {
                ...BuyerIncentives_viewer
            }
        `,
        item: graphql`
            fragment CheckoutMobilePageHeader_item on Item {
                ...BuyerIncentives_item
            }
        `,
        buyer: graphql`
            fragment CheckoutMobilePageHeader_buyer on User {
                isTrade: isVerifiedTrade
                ...BuyerIncentives_buyer
            }
        `,
    }
);
